// extracted by mini-css-extract-plugin
export default {"grid":"FeatureGrid_grid__16qJd","visible":"FeatureGrid_visible__vpheA","item":"FeatureGrid_item__ShLAu","icon":"FeatureGrid_icon__ZfWr6","label":"FeatureGrid_label__VvSC4"};